<app-spin-or-content [isSpin]="isLoading">
	<div class="d-flex justify-content-between">
		@if (!inputRow) {
			<app-gen-button-group
				[actualObj]="this"
				fieldName="userActiveStatus"
				optionsListName="user_active_opts"
				(changeEvent)="filterRows()"
			></app-gen-button-group>
		}
		<app-gen-button-group
			[actualObj]="this"
			fieldName="optStatus"
			optionsListName="patient_active_opts"
			(changeEvent)="filterRows()"
		></app-gen-button-group>

		<app-gen-button-group
			[actualObj]="this"
			fieldName="objsubStatus"
			optionsListName="object_sub_user_opts"
			(changeEvent)="filterRows()"
		></app-gen-button-group>
	</div>
	<div
		id="section-to-print"
		class="sub-user-patients"
	>
		<app-table-wrap
			fieldsStr=",id,name,active,active_assoc,patient_status,assoc_date,update_date,last_followup_time"
		>
			@for (row of rowsShown; track row) {
				<tr [class.subtotal]="row.isSubTotal">
					<td>
						@if (!row.isSubTotal) {
							<app-check
								(onClick)="check(row.id)"
								[isCheck]="checkedIds.includes(row.id)"
							/>
						}
					</td>
					<td>{{ row.item_id }}</td>
					<td [class.link-patient]="!row.isSubTotal">
						<app-patient-modal [id]="row.item_id">
							{{ row.name }}
						</app-patient-modal>
					</td>
					<td>{{ row.patientActive | langVal }}</td>
					<td>
						{{ $safeNavigationMigration(row?.active) | langVal }}
						@if (row?.active == "yes" && permsService?.perms?.administrative) {
							<button
								class="btn btn-primary print_hidden"
								(click)="deactivate(row)"
							>
								{{ "make_not_active" | langVal }}
							</button>
						}
					</td>
					<td style="width: 10%">{{ row.status | langVal }}</td>
					<td>{{ row.created_at | dateFormat }}</td>
					<td>{{ row.updated_at | dateFormat }}</td>
					<td>{{ row.last_followup_time | dateFormat }}</td>
					<!--          <td>{{row.first_followup_time | dateFormat}}</td>-->
					<!--          <td>{{row.last_followup_time | dateFormat}}</td>,first_meeting_date,last_meeting_date-->
				</tr>
			}
		</app-table-wrap>
	</div>
	<div class="modal-btns">
		@if (isModalMode) {
			<app-cancel-btn (click)="onClose.emit()" />
		}
		<button
			tabindex="1"
			class="btn btn-primary"
			(click)="print()"
		>
			{{ "print" | langVal }}
		</button>
		<!--      <button tabindex="-1" class="btn  btn-primary"-->
		<!--              (click)="downloadReport()">{{"create_excel" | langVal}}</button>-->
		<button
			tabindex="1"
			class="btn btn-primary"
			[disabled]="!checkedIds.length"
			[spinner]="isDeactivatingAll"
			(click)="deactivateAll()"
		>
			{{ "make_not_active" | langVal }}
		</button>
	</div>
</app-spin-or-content>
